import type { LucideIcon } from 'lucide-react';
import {
  Users, ClipboardList, Building2, UserCog, Moon, Shield,
  Smartphone, Calendar, Award, Mail, ShoppingCart, Shirt,
  AlertTriangle, Undo2, CheckCircle, Warehouse, Package,
  GraduationCap, BarChart2,
} from 'lucide-react';

export interface NavItem {
  to: string;
  label: string;
  icon: LucideIcon;
  /** app_modules.code that controls visibility */
  moduleCode: string;
}

export interface NavGroup {
  label: string;
  items: NavItem[];
}

export const NAVIGATION_GROUPS: NavGroup[] = [
  {
    label: 'Navigazione',
    items: [
      { to: '/richiedenti-asilo', label: 'Richiedenti Asilo', icon: Users, moduleCode: 'ra_profiles' },
      { to: '/amministrazione', label: 'Amministrazione', icon: ClipboardList, moduleCode: 'amministrazione' },
      { to: '/distribuzione', label: 'Gestione Stanze', icon: Building2, moduleCode: 'amministrazione' },
      { to: '/admin/users', label: 'Gestione Utenti', icon: UserCog, moduleCode: 'amministrazione' },
      { to: '/amministrazione/ramadan', label: 'Gestione Ramadan', icon: Moon, moduleCode: 'amministrazione' },
      { to: '/admin/super', label: 'Super Admin', icon: Shield, moduleCode: 'super_admin' },
      { to: '/capogruppo', label: 'Dashboard Capogruppo', icon: Users, moduleCode: 'capogruppo' },
      { to: '/educatori', label: 'Educatori', icon: GraduationCap, moduleCode: 'educatori' },
      { to: '/pwa', label: 'Dashboard PWA', icon: Smartphone, moduleCode: 'pwa' },
    ],
  },
  {
    label: 'Appuntamenti',
    items: [
      { to: '/amministrazione/appuntamenti', label: 'Gestione Appuntamenti', icon: Calendar, moduleCode: 'appointments' },
      { to: '/amministrazione/appuntamenti/categorie', label: 'Categorie Appuntamenti', icon: Package, moduleCode: 'appointments' },
    ],
  },
  {
    label: 'Programma GEP',
    items: [
      { to: '/gep', label: 'Programma GEP', icon: Award, moduleCode: 'gep' },
      { to: '/gep/activities/record', label: 'Registra Attivita', icon: Award, moduleCode: 'gep' },
      { to: '/gep/work-days/record', label: 'Registra Giornate GEP', icon: Calendar, moduleCode: 'gep' },
      { to: '/gep/eligible', label: 'Ammissibili GEP', icon: Users, moduleCode: 'gep' },
      { to: '/gep/groups', label: 'Gruppi di Lavoro', icon: Users, moduleCode: 'gep' },
      { to: '/gep/activities', label: 'Config Attivita', icon: Package, moduleCode: 'gep' },
    ],
  },
  {
    label: 'Comunicazioni',
    items: [
      { to: '/email-procedures', label: 'Procedure Email', icon: Mail, moduleCode: 'email_procedures' },
    ],
  },
  {
    label: 'Shop & Servizi',
    items: [
      { to: '/shop', label: 'Shop', icon: ShoppingCart, moduleCode: 'shop' },
      { to: '/shop/laundry-management', label: 'Reti e Transfer', icon: Shirt, moduleCode: 'laundry' },
      { to: '/shop/laundry/forgotten-tickets', label: 'Ticket Dimenticati', icon: AlertTriangle, moduleCode: 'laundry' },
      { to: '/shop/gestione-restituzioni', label: 'Restituzioni', icon: Undo2, moduleCode: 'shop' },
      { to: '/clothing/stock', label: 'Gestione Vestiti', icon: Shirt, moduleCode: 'clothing' },
      { to: '/clothing/requests', label: 'Richieste Vestiti', icon: ClipboardList, moduleCode: 'clothing' },
      { to: '/shop/transfer-verification', label: 'Verifica Transfer', icon: CheckCircle, moduleCode: 'shop' },
      { to: '/shop/statistiche', label: 'Statistiche & Operazioni', icon: BarChart2, moduleCode: 'shop' },
      { to: '/shop/ticket-inventory', label: 'Inventario Biglietti', icon: Warehouse, moduleCode: 'train_tickets' },
    ],
  },
];
